export default __webpack_public_path__ + "static/media/bB.55ed8960.svg";